//
export const sel = (e) => document.querySelector(e)
export const selAll = (e) => document.querySelectorAll(e)
export const dev = import.meta.env.DEV
const ua = navigator.userAgent
export const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua) // iOS / iPadOS (any browser on iOS since all use WebKit)
export const isIOS = () => {
  const ua = navigator.userAgent || ''
  const platform = navigator.platform || ''
  const maxTouch = navigator.maxTouchPoints || 0

  // Classic iOS (iPhone / iPod / old iPad)
  if (/iPhone|iPod|iPad/i.test(ua)) return true

  // iPadOS 13+ often reports as "MacIntel"
  if (platform === 'MacIntel' && maxTouch > 1) return true

  return false
}

// one-time install guarded by a global flag
const KEY = Symbol.for('@@sel.install')
if (!globalThis[KEY]) {
  globalThis[KEY] = true
  for (const proto of [Element.prototype, Document.prototype, DocumentFragment.prototype]) {
    if (!Object.prototype.hasOwnProperty.call(proto, 'sel')) {
      Object.defineProperty(proto, 'sel', {
        value(s) {
          return this.querySelector(s)
        },
        configurable: true,
      })
    }
    if (!Object.prototype.hasOwnProperty.call(proto, 'selAll')) {
      Object.defineProperty(proto, 'selAll', {
        value(s) {
          return Array.from(this.querySelectorAll(s))
        },
        configurable: true,
      })
    }
  }
}

export const vh = (percent) => window.innerHeight * (percent / 100)
export const vw = (percent) => window.innerWidth * (percent / 100)
export const mm = gsap.matchMedia()
export const notHiddenAB = ':not([data-wf-hidden-variation] *)'

export const isDomEl = (el) => el instanceof Document || el instanceof Element
export const l = (...e) => console.debug(...e)

export const bp = {
  mob: '(max-width: 478px)',
  land: '(min-width: 479px) and (max-width: 767px)',
  tab: '(min-width: 768px) and (max-width: 991px)',
  desk: '(min-width: 992px) and (max-width: 1279px)',
  l: '(min-width: 1280px) and (max-width: 1439px)',
  xl: '(min-width: 1440px) and (max-width: 1919px)',
  xxl: '(min-width: 1920px)',
  landUp: '(min-width: 479px)',
  tabUp: '(min-width: 768px)',
  deskUp: '(min-width: 992px)',
  lUp: '(min-width: 1280px)',
  xlUp: '(min-width: 1440px)',
  landDown: '(max-width: 767px)',
  tabDown: '(max-width: 991px)',
  deskDown: '(max-width: 1279px)',
  lDown: '(max-width: 1439px)',
  xlDown: '(max-width: 1919px)',
}

export function selector(el) {
  if (isDomEl(el)) return el

  if (typeof el === 'string' && el.charAt(0) !== '.' && el.charAt(0) !== '[' && el.charAt(0) !== '#' && el.length > 1) el = '.' + el

  return document.querySelector(el)
}

export function pauseVideos() {
  if (!import.meta.env.DEV) return
  console.log('pauseVideos')
  setTimeout(() => {
    document.querySelectorAll('video').forEach((video) => video.pause())
  }, 1000)
}
// export function debounce(func, time = 100) {
//   let timer = 0
//   return function (event) {
//     if (timer) clearTimeout(timer)
//     timer = setTimeout(func, time, event)
//   }
// }
export function debounce(func, timeout = 100) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
export function devMode(mode) {
  if (mode === 0) {
    return
  } else if (mode === 1) {
    let i = 0
    document.querySelectorAll('[data-video-urls]').forEach((el) => {
      el.querySelector('video').remove()
      i++
    })
    console.log('devMode, removed videos:', i)
  } else if (mode === 2) {
    const devRemoveList = []
    // const devRemoveList = [videoHero$, introSec$, aboutSec$]
    devRemoveList.forEach((el) => {
      el.remove()
    })
    console.log('devMode: removing sections')
  }
}

export function removeSplideClasses(el) {
  const splide = selector(el)
  const track = splide.querySelector('.splide__track')
  const list = splide.querySelector('.splide__list')
  const slide = splide.querySelectorAll('.splide__slide')
  splide.classList.remove('splide')
  track.classList.remove('splide__track')
  list.classList.remove('splide__list')
  slide.forEach((slide) => slide.classList.remove('splide__slide'))
}
export function addSplideClasses(el, trackClass = '') {
  let splide = selector(el)
  // const track = splide.children[0]
  // const track = splide.querySelector('.w-dyn-list')
  const track = trackClass === '' ? splide.querySelector('.w-dyn-list') : splide.querySelector(trackClass)

  const list = track.querySelector('.w-dyn-items')
  const slide = list.childNodes

  splide.classList.add('splide')
  track.classList.add('splide__track')
  list.classList.add('splide__list')
  slide.forEach((slide) => slide.classList.add('splide__slide'))
}

export function addStaticSplideClasses(el, trackClass = '') {
  let splide = selector(el)
  const track = trackClass === '' ? splide.firstChild : splide.querySelector(trackClass)
  // console.log(splide, track, trackClass)

  const list = track.firstChild
  const slide = list.childNodes

  splide.classList.add('splide')
  track.classList.add('splide__track')
  list.classList.add('splide__list')
  slide.forEach((slide) => slide.classList.add('splide__slide'))
}

export function connectSplideArrows(splide, arrowW, _arrow = '.arrow') {
  // if (!splide.length) return console.log('splide not found/mounted', splide)
  const arrowW$ = selector(arrowW)
  const leftArrow$ = arrowW$.querySelector(_arrow + '.is--left')
  const rightArrow$ = arrowW$.querySelector(_arrow + ':not(.is--left)')
  if (!leftArrow$ || !rightArrow$) return console.log('arrows not found', 'left:', leftArrow$, 'right:', rightArrow$, 'in wrapper:', arrowW$, 'slide:', splide)

  arrowW$.style.overflow = 'hidden'

  const pages = Math.ceil(splide.length / splide.options.perPage)
  // console.log('connectSplideArrows pages:', pages)

  if (pages > 1) {
    arrowW$.style.maxHeight = 'revert-layer' // to get the initial css value

    leftArrow$.addEventListener('pointerdown', function () {
      splide.go('<')
      // console.log('left arrow clicked')
    })
    rightArrow$.addEventListener('pointerdown', function () {
      splide.go('>')
      // console.log('right arrow clicked')
    })
  } else {
    // keep the dom elements to repopulate in the future
    arrowW$.style.maxHeight = '0px'
  }
}
export function connectSplideBullets(splide, el) {
  // parse bullets inside the container and repopulate
  const pagination$ = selector(el)
  let bulletPressed = false
  if (splide.length > 1) {
    const bullet$ = pagination$?.querySelector('[class*="bullet"]:not(.is--active)')
    if (!bullet$) return console.log('bullet not found', bullet$, 'in:', pagination$)
    let fragment = document.createDocumentFragment()
    for (let i = 0; i < splide.length; i++) {
      let clone$ = bullet$.cloneNode(true)
      clone$.addEventListener('click', (e) => {
        bulletPressed = true
        splide.go(i)
      })
      fragment.appendChild(clone$)
    }
    fragment.firstChild.classList.add('is--active')
    pagination$.replaceChildren(fragment)
  } else {
    pagination$.replaceChildren()
  }
  splide.on('move', function (newIndex, oldIndex) {
    selector(el).querySelector('.is--active').classList.remove('is--active')
    selector(el)
      .querySelector(`[class*="bullet"]:nth-of-type(${splide.index + 1})`)
      .classList.add('is--active')
  })
}
export function connectSplideCarouselBullets(splide, el) {
  const slider$ = splide.root
  const pagination$ = selector(el)
  pagination$.parentElement.style.overflow = 'hidden'

  let pages = 1
  // parse bullets inside the container and repopulate
  function initSate() {
    // console.log('connectSplideCarouselBullets', slider$, pagination$)
    pages = Math.ceil(splide.length / splide.options.perPage)

    if (pages > 1) {
      // console.log('creating bullets, pages:', pages)
      pagination$.parentElement.style.maxHeight = 'revert-layer' // to get the initial css value

      const bullet$ = pagination$.querySelector('.bullet:not(.is--active)')

      let fragment = document.createDocumentFragment()
      for (let i = 0; i < pages; i++) {
        // console.log('creating bullet', i)
        let clone$ = bullet$.cloneNode(true)
        clone$.addEventListener('click', (e) => {
          splide.go('>' + i)
          // console.log('bullet clicked', i)
        })
        fragment.appendChild(clone$)
      }
      fragment.firstChild.classList.add('is--active')
      pagination$.replaceChildren(fragment)
    } else {
      // keep the dom elements to repopulate in the future
      pagination$.parentElement.style.maxHeight = '0px'
      // console.log('removing bullets')
    }
  }
  function initBullets(newIndex = splide.index) {
    const index = Math.ceil(newIndex / splide.options.perPage)

    pagination$.querySelector('.is--active')?.classList.remove('is--active')
    pagination$.querySelector(`.bullet:nth-of-type(${index + 1})`)?.classList.add('is--active')
  }

  splide.on('mounted resized', function () {
    // console.log('splide mounted/resized')
    initSate()
    splide.go(0)
    // updateBullets()
  })
  splide.on('move ', function (newIndex, oldIndex) {
    if (pages < 2) return
    // const index = splide.Components.Controller.toPage(splide.index) // works but the calculation can be wrong as the bullets are manually added
    initBullets(newIndex)
  })
  setTimeout(() => {
    if (!splide.state.is('mounted')) {
      initSate()
    }
  }, 1000)
}

export function splideAutoWidth(splide) {
  // if not enough logos it will center them and stop the slider
  const Components = splide.Components
  // to remove duplicates for inactive/small slider
  splide.on('overflow', function (isOverflow) {
    splide.go(0) // Reset the carousel position

    splide.options = {
      focus: isOverflow ? 'center' : '',
      drag: isOverflow ? 'free' : false,
      clones: isOverflow ? undefined : 0, // Toggle clones
    }
  })
  let sliderOverflow = true
  let sliderReady = false
  // to center inactive/small slider
  splide.on('resized', function () {
    var isOverflow = Components.Layout.isOverflow()
    sliderOverflow = isOverflow
    var list = Components.Elements.list
    var lastSlide = Components.Slides.getAt(splide.length - 1)

    if (lastSlide) {
      // Toggles `justify-content: center`
      list.style.justifyContent = isOverflow ? 'flex-start' : 'center'

      // Remove the last margin
      if (!isOverflow) {
        lastSlide.slide.style.marginRight = ''
      }
    }
    if (sliderReady) {
      splideInit()
    }
  })
  splide.on('mounted', splideInit)
  function splideInit() {
    sliderReady = true
    if (!sliderOverflow) {
      splide.Components.AutoScroll.pause()
    } else if (sliderOverflow && splide.Components.AutoScroll.isPaused()) {
      // } else if (sliderOverflow && splide.Components.AutoScroll?.isPaused()) {
      splide.Components.AutoScroll.play()
    }
  }
}

export function onDomReady(run) {
  if (document.readyState !== 'loading') {
    run()
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      run()
    })
  }
}

// Add an observer that checks if a class exists. If it does remove the observer and call a function
export function addObserver(element, className, callback) {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        observer.disconnect()
        callback()
      }
    })
  })
  observer.observe(element, {
    attributes: true,
    attributeFilter: ['class'],
  })
}

// run a callback on change with the delay, if another change occurs before the delay, the timer resets
export function initObserver(element$, timeout = 100, observerName = 'default', callback) {
  if (element$?.observer?.[observerName]) return
  let timerId = 0

  const observer = new MutationObserver(function (mutations) {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      // console.log(observerName, element$)
      callback()
      // observer.disconnect()
    }, timeout)
  })

  observer.observe(element$, { childList: true, attributes: true })
  element$.observer = element$.observer || {}
  element$.observer[observerName] = observer
}

// run one callback when class is added and another when it is removed
export function classAddedRemovedObserver(element, className, addedCallback, removedCallback) {
  const element$ = selector(element)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const classList = mutation.target.classList
        if (classList.contains(className)) {
          addedCallback()
          // console.log('Class ' + className + ' added')
        } else {
          removedCallback()
          // console.log('Class ' + className + ' removed')
        }
      }
    })
  })

  observer.observe(element$, { attributes: true })
}

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export function scrollTriggerInit(distance = 0, elClassName = '', sectionClassName = '', fromToType = '', topMiddleBottom = '', markers = false) {
  const tlType = fromToType === '' ? 'fromTo' : fromToType
  const stPosition = topMiddleBottom === '' ? 'middle' : topMiddleBottom
  // negative distance = front object (faster on scroll), positive distance = back object (slower on scroll/more sticky)
  const tl = gsap.timeline({ defaults: { ease: 'none' } })
  if (tlType === 'fromTo') {
    let fromDistance = -distance,
      toDistance = distance
    // remove the minus sign in a string for fromDistance
    if (typeof distance === 'string' && distance.charAt(0) === '-') fromDistance = distance.substring(1)

    tl.fromTo('.' + elClassName, { y: fromDistance }, { y: toDistance })
  } else if (tlType === 'to') {
    tl.to('.' + elClassName, { y: distance })
    console.log('to')
  } else if (tlType === 'from') {
    console.log('from')
    tl.from('.' + elClassName, { y: distance })
  }

  let start = 'top bottom'
  let end = 'bottom top'
  if (stPosition === 'top') {
    start = 'top top'
  } else if (stPosition === 'bottom') {
    end = 'bottom bottom'
  }

  sectionClassName = sectionClassName || elClassName
  return ScrollTrigger.create({
    animation: tl,
    trigger: '.' + sectionClassName,
    start: start,
    end: end,
    markers: markers,
    scrub: true,
    delay: 0.0,
  })
}

export function addSwiperClasses(slider) {
  const swiper = document.querySelector('.' + slider)
  const list = swiper.children[0]
  const slide = list.childNodes
  swiper.classList.add('swiper')
  list.classList.add('swiper-wrapper')
  slide.forEach((slide) => slide.classList.add('swiper-slide'))
}

export function getSiblings(e) {
  let siblings = []
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild
  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling)
    }
    sibling = sibling.nextSibling
  }
  return siblings
}

export function getLineNum(el) {
  const textarea = el
  // console.log('textarea', textarea)

  const parseValue = (v) => (v.endsWith('px') ? parseInt(v.slice(0, -2), 10) : 0)

  const calculateNumLines = (str) => {
    const textareaStyles = window.getComputedStyle(textarea)
    const font = `${textareaStyles.fontSize} ${textareaStyles.fontFamily}`
    const paddingLeft = parseValue(textareaStyles.paddingLeft)
    const paddingRight = parseValue(textareaStyles.paddingRight)
    const textareaWidth = textarea.getBoundingClientRect().width - paddingLeft - paddingRight
    // console.log(textareaWidth, font)

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    context.font = font

    const words = str.split(' ')
    let lineCount = 0
    let currentLine = ''
    for (let i = 0; i < words.length; i++) {
      const wordWidth = context.measureText(words[i] + ' ').width
      const lineWidth = context.measureText(currentLine).width

      if (lineWidth + wordWidth > textareaWidth) {
        lineCount++
        currentLine = words[i] + ' '
      } else {
        currentLine += words[i] + ' '
      }
    }

    if (currentLine.trim() !== '') {
      lineCount++
    }

    return lineCount
  }
  return calculateNumLines(el.textContent)
  // return el.value.split('\n').length
}

export function wfSliderArrows() {
  const arrows$a = selAll('[slider-arrows]')
  arrows$a.forEach((el) => {
    const providedSelector = el.getAttribute('slider-arrows')
    const placedInside = !providedSelector && providedSelector === ''

    const slider$ = placedInside ? el.closest('.w-slider') : selector(providedSelector)
    // if (slider$.arrowsAttached) return
    // stop if invoked by arrows from within 2nd time, the arrows are connected already
    if (slider$.hasAttribute('arrows-attached') && placedInside) return

    const wfLeftArrow$ = slider$.querySelector('.w-slider-arrow-left')
    const wfRightArrow$ = slider$.querySelector('.w-slider-arrow-right')
    const customLeftArrow$a = slider$.querySelectorAll('.arrow.is--left')
    const customRightArrow$a = slider$.querySelectorAll('.arrow:not(.is--left)')
    customLeftArrow$a.forEach((el) => {
      el.addEventListener('click', function () {
        wfLeftArrow$.click()
      })
    })
    customRightArrow$a.forEach((el) => {
      el.addEventListener('click', function () {
        wfRightArrow$.click()
      })
    })
    // slider$.arrowsAttached = true
    if (placedInside) slider$.setAttribute('arrows-attached', '')
  })
}

export function wfTabs() {
  const customTabs$a = selAll('[tabs-nav]')
  customTabs$a.forEach((customTabs) => {
    const providedSelector = customTabs.getAttribute('tabs-nav')
    const placedInside = !providedSelector && providedSelector === ''
    const tabs$ = placedInside ? customTabs.closest('.w-tabs') : selector(providedSelector)
    // stop if invoked by tabs from within 2nd time, all tabs are connected already
    if (tabs$.hasAttribute('tabs-attached') && placedInside) return

    const customTabs$a = customTabs.querySelectorAll('a')
    customTabs$a.forEach((customTabsTab, i) => {
      customTabsTab.addEventListener('click', function () {
        customTabs.querySelectorAll('.is--active').forEach((el) => el.classList.remove('is--active'))
        customTabsTab.classList.add('is--active')
        const wfTab = tabs$.querySelector('[id$="-data-w-tab-' + i + '"]')
        wfTab.click()
      })
    })
    tabs$.setAttribute('tabs-attached', '')
  })
}

export function stResizeObserver() {
  let documentHeight = document.body.clientHeight
  new ResizeObserver((entries) => {
    const newHeight = entries[0].contentRect.height // only one item [0] - body
    if (newHeight !== documentHeight) {
      documentHeight = newHeight
      ScrollTrigger.refresh()
      // console.log('observer')
    }
  }).observe(document.body)
}
export function disableWfScroll() {
  var Webflow = Webflow || []
  Webflow.push(function () {
    //DISABLE WEBFLOW SMOOTH SCROLL
    ;() => {
      sel('document').off('click.wf-scroll')
    }
  })
}

// https://gsap.com/docs/v3/HelperFunctions/helpers/callAfterResize/
export function callAfterResize(func, delay) {
  let dc = gsap.delayedCall(delay || 0.2, func).pause(),
    handler = () => dc.restart(true)
  window.addEventListener('resize', handler)

  return handler // in case you want to window.removeEventListener() later
}

export function preventOrphan(el, keep = 2) {
  // replaces the last breakable spaces with NBSP so the last `keep` words stick together
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
  const nodes = []
  while (walker.nextNode()) nodes.push(walker.currentNode)

  let spacesToReplace = keep - 1 // e.g. 2 words => replace 1 space
  for (let i = nodes.length - 1; i >= 0 && spacesToReplace > 0; i--) {
    const t = nodes[i]
    // replace from the end, one space per loop
    let idx = t.data.lastIndexOf(' ')
    if (idx > -1) {
      t.data = t.data.slice(0, idx) + '\u00A0' + t.data.slice(idx + 1)
      spacesToReplace--
      i++ // recheck the same node in case there are more trailing spaces
    }
  }
}

export function wrapLastTwo(el) {
  el.normalize()
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
  const texts = []
  while (walker.nextNode()) texts.push(walker.currentNode)
  if (!texts.length) return

  // Find the final space across all text nodes
  for (let i = texts.length - 1; i >= 0; i--) {
    const t = texts[i]
    const m = t.data.match(/^(.*)\s+(\S+)\s*$/)
    if (!m) continue

    // replace tail with “ rest ” + <span class=no-wrap>lastWord</span>
    t.data = m[1] + ' '
    const span = document.createElement('span')
    span.className = 'no-wrap'
    span.textContent = m[2]

    // pull previous word (from the same node) into the span if possible
    const m2 = t.data.match(/^(.*)\s+(\S+)\s$/)
    if (m2) {
      t.data = m2[1] + ' '
      span.textContent = m2[2] + ' ' + span.textContent
    }
    texts[i].parentNode.insertBefore(span, texts[i].nextSibling)
    break
  }
}

let _fontsReadyPromise = null

/**
 * Run a callback after DOM is ready and selected variable-font faces are warmed.
 *
 * @param {Function} callback       - Code to run once ready.
 * @param {Object}   opts
 * @param {string}   opts.family    - CSS font-family name.
 * @param {number[]|string[]} opts.weights - Weights to warm (e.g., [300, 700]).
 * @param {string[]} opts.styles    - Styles to warm (e.g., ['normal', 'italic']).
 * @param {string}   opts.size      - Probe size for Font Loading API.
 * @param {'dom'|'load'} opts.wait  - Wait for DOM or full window load.
 * @param {number}   opts.timeoutMs - Max time to wait before proceeding.
 */
export function onDOMAndFontsReady(
  callback,
  { family = 'DM Sans', weights = [400, 700], styles = ['normal'], size = '1rem', wait = 'dom', timeoutMs = 8000 } = {}
) {
  // Create (or reuse) a singleton promise that waits for DOM + fonts.
  if (!_fontsReadyPromise) {
    const domReady = new Promise((resolve) => {
      if (wait === 'load') {
        if (document.readyState === 'complete') resolve()
        else window.addEventListener('load', resolve, { once: true })
      } else {
        if (document.readyState !== 'loading') resolve()
        else document.addEventListener('DOMContentLoaded', resolve, { once: true })
      }
    })

    const facePromises = []
    for (const style of styles) {
      for (const weight of weights) {
        facePromises.push(document.fonts.load(`${style} ${weight} ${size} "${family}"`))
      }
    }
    // Also wait for the document's font set to settle.
    facePromises.push(document.fonts.ready)

    const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error('Font load timed out')), timeoutMs))

    _fontsReadyPromise = Promise.all([domReady, Promise.race([Promise.all(facePromises), timeout])]).catch((err) => {
      // Don’t block forever—resolve even if fonts timed out, but surface the error.
      console.warn('[onDOMAndFontsReady] Proceeding after error:', err)
    })
  }

  // Attach your callback; run on next microtask to avoid reflow thrash.
  _fontsReadyPromise.then(() => {
    try {
      queueMicrotask(() => callback())
    } catch (e) {
      console.error('[onDOMAndFontsReady] callback error:', e)
    }
  })
}
